// These routes can reset their local data when the selected species changes.
// Routes outside this list still return to /home until their requests are audited.
export const SPECIES_DATA_ROUTES = new Set([
  '/library',
  '/dashboard-management', '/table-management',
  '/technical-visit', '/quality-visit', '/dashboard-visit',
  '/dashboard-quality-control',
  '/counting', '/counting-plants', '/counting-quarters',
  '/counting-heatmap', '/counting-orchard-heatmap', '/counting-dashboard',
  '/schedule-form',
  '/schedule2-dashboard', '/schedule2-list',
  '/schedule-history', '/schedule-historyday',
  '/check-day', '/check-biweekly', '/check-pentaweekly',
  '/check-day-form', '/estimate-day-form',
  '/producer-certification',
]);

export const supportsInPlaceSpeciesChange = pathname =>
  SPECIES_DATA_ROUTES.has(pathname.toLowerCase().replace(/\/+$/, ''));

// These views observe the global species and execute their own replacement query.
// Recreating them would hide the change from their effects and skip that query.
const SPECIES_REFRESH_ROUTES = new Set([
  '/dashboard-management', '/table-management',
  '/technical-visit', '/quality-visit', '/dashboard-visit',
  '/dashboard-quality-control',
]);

export const remountOnSpeciesChange = pathname =>
  supportsInPlaceSpeciesChange(pathname) &&
  !SPECIES_REFRESH_ROUTES.has(pathname.toLowerCase().replace(/\/+$/, ''));
